import { render, staticRenderFns } from "./RateCoach.vue?vue&type=template&id=16c01212&scoped=true"
import script from "./RateCoach.vue?vue&type=script&lang=js"
export * from "./RateCoach.vue?vue&type=script&lang=js"
import style0 from "./RateCoach.vue?vue&type=style&index=0&id=16c01212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c01212",
  null
  
)

export default component.exports